/**
 * Created by rickborst on 22/02/2017.
 */

import {LoggedInStatuses, ActionTypes, SessionStatuses, AdBlockStatuses} from 'store/actions/session';

import Session from 'models/session';

const defaultSessionState = Object.assign({
    loggedIn: LoggedInStatuses.UNAUTHORIZED,
    wasUpdated: false,
    redirectUrl: ''
}, new Session());

/**
 * Logged in status logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function loggedInStatus (state = LoggedInStatuses.UNAUTHORIZED, action) {

    switch (action.type) {

        case ActionTypes.SET_LOGGED_IN_STATUS:
            state = action.status;
            return state;

        default:
            return state;
    }
}

/**
 * Session status for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function sessionStatus (state = SessionStatuses.CAN_REFRESH, action) {

    switch (action.type) {

        case ActionTypes.SET_SESSION_STATUS:
            state = action.sessionStatus;
            return state;

        default:
            return state;
    }
}

/**
 * Update adBlock status.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function adBlockStatus (state = AdBlockStatuses.NOT_DETECTED, action) {

    if (state !== action.adBlockStatus) {
        state = action.adBlockStatus;
    }
    return state;
}

/**
 * Redirect URL logic for state change.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Payload for the action.
 * @returns {Object} Next state of the component.
 */
function redirectUrl (state = '', action) {

    switch (action.type) {

        case ActionTypes.SET_REDIRECT_URL:
            state = action.url;
            return state;

        default:
            return state;
    }
}

/**
 * Session reducer.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Action payload.
 * @returns {Object} Session reducer.
 */
function session (state = defaultSessionState, action) {

    switch (action.type) {

        case ActionTypes.UPDATE_SESSION:
            return {
                ...action.session,
                loggedIn: loggedInStatus(state.loggedIn, action),
                redirectUrl: redirectUrl(state.redirectUrl, action),
                sessionStatus: sessionStatus(state.sessionStatus, action)
            };

        case ActionTypes.SET_REDIRECT_URL:
            return {
                ...state,
                loggedIn: loggedInStatus(state.loggedIn, action),
                redirectUrl: redirectUrl(state.redirectUrl, action),
                sessionStatus: sessionStatus(state.sessionStatus, action)
            };

        case ActionTypes.SET_LOGGED_IN_STATUS:
            return {
                ...state,
                loggedIn: loggedInStatus(state.loggedIn, action),
                redirectUrl: redirectUrl(state.redirectUrl, action),
                sessionStatus: sessionStatus(state.sessionStatus, action),
                wasUpdated: true
            };

        case ActionTypes.SET_SESSION_STATUS:
            return {
                ...state,
                sessionStatus: sessionStatus(state.sessionStatus, action)
            };

        case ActionTypes.SET_ADBLOCK_STATUS:
            return {
                ...state,
                adBlockStatus: adBlockStatus(state.adBlockStatus, action)
            };

        default:
            return state;
    }
}

export default session;


// WEBPACK FOOTER //
// ./src/js/store/reducers/session.js